<template>
    <div>
        <div class="grid-container">
            <div v-for="(productsItem, index) in products" :key="index + 'grid'" class="grid-item" @click="getInfo(productsItem)">
                <img :src="productsItem.src" alt="">
                <h3>{{productsItem.name}}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import { products } from '@/view/products';

export default {
    name: 'ProductsText',
    data() {
        return {
            products
        }
    },
    methods: {
        getInfo(val) {
            var rowData = val;
            sessionStorage.setItem("rowData", JSON.stringify(rowData));
            this.$router.push({
                name: "ProductsDetail"
            });
        }
    }
}
</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
.grid-container {
    display: grid;
    width: 70%;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px; /* 格子之间的间距 */
    margin: auto;
    margin-top: 50px;
    text-align: left;
}

.grid-item  img{
    width: 100%;
    height: 230px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2em;
    margin: auto;
}
.grid-container a {
    font-size: 14px;
    color: #1e7962;
    padding: 0 20px 20px;
    display: block;
    text-decoration: none;
}
h3 {
    padding: 0 20px;
}
</style>